import { createApp } from "vue";
import StyleMessage from "./StyleMessage.vue";

const MESSAGE_HEIGHT = 54;

const Message = {
  createInstance(config) {
    const messageNode = document.createElement("div");
    messageNode.className = "message";

    const messageList = document.getElementsByClassName("message");
    messageNode.style.top = `${messageList.length * MESSAGE_HEIGHT}px`;

    const handleRemove = () => {
      document.body.removeChild(messageNode);

      app.unmount();

      const messages = document.getElementsByClassName("message");
      for (let i = 0; i < messages.length; i++) {
        messages[i].style.top = `${i * MESSAGE_HEIGHT}px`;
      }
    };

    const app = createApp(StyleMessage, {
      config,
      remove: handleRemove,
    });

    app.vm = app.mount(messageNode);
    document.body.appendChild(messageNode);

    app.close = () => {
      handleRemove();
    };

    return app;
  },

  text(options) {
    const config =
      typeof options === "string" ? { content: options } : { ...options };

    config.duration = config.duration !== undefined ? config.duration : 3000;

    return this.createInstance(config);
  },
};

export default Message;
